import { render, staticRenderFns } from "./BDXEditFormCurrency.vue?vue&type=template&id=108700a8"
import script from "./BDXEditFormCurrency.vue?vue&type=script&lang=js"
export * from "./BDXEditFormCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports